import { httpClient } from '@/api/http-client'
import { Partner } from '@/types/partner'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
type Params = {
  partnerKey: string
  companyKey: string
}

export const readPartner = async ({ partnerKey, companyKey }: Params) => {
  const response = await httpClient('accounting-dealer').get<Partner>(
    `v3/company/${companyKey}/partner/${partnerKey}`,
  )
  return response.data
}

export const useReadPartner = (
  { partnerKey, companyKey }: Params,
  options?: Partial<UseQueryOptions<Partner>>,
) => {
  return useQuery({
    queryKey: ['partner', companyKey, partnerKey],
    queryFn: () => readPartner({ partnerKey, companyKey }),
    ...options,
  })
}
